<mat-sidenav-container class="mainWrapper blue_theme  light-theme" autosize autoFocus dir="ltr">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->

  <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {           
              <app-nav-item [item]="item" (notify)="sidenav.toggle()">
              </app-nav-item>                  
          }
        </mat-nav-list>
      </ng-scrollbar>
    </div>
  </mat-sidenav>


  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>

    <main class="pageWrapper maxWidth">
      <!-- ============================================================== -->
      <!-- VerticalHeader -->
      <!-- ============================================================== -->

      <ng-container>
        <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()"
          (toggleMobileNav)="sidenav.toggle()"></app-header>
      </ng-container>


      <div class="m-t-30">

        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
      </div>

    </main>
  </mat-sidenav-content>
</mat-sidenav-container>